import { Link as MuiLink, LinkProps } from "@material-ui/core";
import * as React from "react";
import { Link as RouterLink } from "react-router-dom";

export function Link(props: LinkProps): React.ReactElement {
  return (
    <MuiLink {...{ ...props, ...{ component: RouterLink, to: props.href } }} />
  );
}
